import React from "react";

const ReportIcon = ({ size = 18, color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M16 3C17.1046 3 18 3.89543 18 5V10.75C18 11.8546 17.1046 12.75 16 12.75H9.75C9.2863 12.7481 8.83453 12.6029 8.45648 12.3344C8.07842 12.0659 7.79256 11.6872 7.638 11.25H10.5C10.8978 11.25 11.2794 11.092 11.5607 10.8107C11.842 10.5294 12 10.1478 12 9.75V3H16ZM1.5 9.75H9.5C10.0523 9.75 10.5 9.30228 10.5 8.75V2.25C10.5 1.65326 10.2629 1.08097 9.84099 0.65901C9.41903 0.237053 8.84674 0 8.25 0L0 0V17.25C0 17.6642 0.335786 18 0.75 18C1.16421 18 1.5 17.6642 1.5 17.25V9.75Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ReportIcon;
